import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../config/firebase';

export const imageService = {
  // Upload an image and return the download URL
  async uploadImage(file, path) {
    try {
      // Create a reference to the file location
      const imageRef = ref(storage, path);

      // Upload the file
      const snapshot = await uploadBytes(imageRef, file);

      // Get the download URL
      const downloadURL = await getDownloadURL(snapshot.ref);

      return downloadURL;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw new Error('Failed to upload image');
    }
  },

  // Upload event cover image
  async uploadEventCoverImage(eventId, file) {
    // Generate a unique filename with timestamp
    const timestamp = Date.now();
    const fileExtension = file.name.split('.').pop();
    const fileName = `cover_${timestamp}.${fileExtension}`;
    const path = `events/${eventId}/cover/${fileName}`;

    return await this.uploadImage(file, path);
  },

  // Upload fighter photo
  async uploadFighterPhoto(fighterId, file) {
    // Generate a unique filename with timestamp
    const timestamp = Date.now();
    const fileExtension = file.name.split('.').pop();
    const fileName = `photo_${timestamp}.${fileExtension}`;
    const path = `fighters/${fighterId}/${fileName}`;

    return await this.uploadImage(file, path);
  },

  // Delete an image from storage
  async deleteImage(imageUrl) {
    try {
      // Create a reference from the URL
      const imageRef = ref(storage, imageUrl);

      // Delete the file
      await deleteObject(imageRef);
    } catch (error) {
      console.error('Error deleting image:', error);
      // Don't throw error for deletion failures - image might already be deleted
    }
  },

  // Validate image file
  validateImageFile(file) {
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      return { isValid: false, error: 'Please select a valid image file (JPEG, PNG, or WebP)' };
    }

    if (file.size > maxSize) {
      return { isValid: false, error: 'Image size must be less than 5MB' };
    }

    return { isValid: true };
  },

  // Create a preview URL for a file
  createPreviewUrl(file) {
    return URL.createObjectURL(file);
  },

  // Clean up preview URL
  revokePreviewUrl(url) {
    URL.revokeObjectURL(url);
  }
};
